module.exports = __webpack_public_path__ + "static/img/44.72b3f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/air/44.png
// module id = 2Yeg
// module chunks = 0